import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { DocumentSearchPageParameterModel } from "@us/Store/Data/DocumentSearchPage/DocumentSearchPageState";

import { Draft } from "immer";

const pagination: DocumentSearchPageParameterModel ={
    initialDocumentTypes: "",
    query: "",
    searchCategoryFilter: "",
    sort: "",
    page: 0,
    pageSize: 0
}

const reducer = {
    "Custom/DocumentSearchData/SetDocumentSearchPage": (
        draft: Draft<DocumentSearchPageParameterModel>,
        action: { result: DocumentSearchPageParameterModel },
    ) => {
        draft.page = action.result.page;
        draft.initialDocumentTypes = action.result.initialDocumentTypes;
        draft.pageSize = action.result.pageSize;
        draft.sort = action.result.sort;
        draft.query = action.result.query;
        draft.searchCategoryFilter = action.result.searchCategoryFilter;
    },
};

export default createTypedReducerWithImmer(pagination, reducer);